import React, { useEffect, useState } from "react";
import { Descriptions, Drawer, Divider, Tag, message } from "antd";
import dayjs from "dayjs";
import service from "../../api/FetchInterceptor";

const statusColors = {
    PENDING: "orange",
    CONFIRMED: "green",
    CANCELLED: "red",
    DONE: "blue",
};

const money = (v) => (v !== null && v !== undefined ? Number(v).toLocaleString() : "-");

const ShowAppointment = ({ id, open, setOpen }) => {
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(null);

    const load = () => {
        if (!id) return;
        setLoading(true);

        service({ method: "GET", url: `admin/appointments/${id}` })
            .then((res) => {
                const data = res.data ?? res;
                setItem(data);
            })
            .catch(() => message.error("Erreur chargement rendez-vous"))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (open) load();
        else setItem(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, id]);

    return (
        <Drawer
            title="Détail rendez-vous"
            open={open}
            onClose={() => setOpen(false)}
            width={720}
            destroyOnClose
        >
            <Descriptions bordered size="small" column={1} loading={loading}>
                <Descriptions.Item label="Code">{item?.code ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Date / Heure">
                    {item?.scheduled_at ? dayjs(item.scheduled_at).format("DD/MM/YYYY HH:mm") : "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Statut">
                    <Tag color={statusColors[item?.status] ?? "default"}>{item?.status ?? "-"}</Tag>
                </Descriptions.Item>
                <Descriptions.Item label="Notes">{item?.notes ?? "-"}</Descriptions.Item>
            </Descriptions>

            <Divider />

            <Descriptions bordered size="small" column={2} loading={loading}>
                <Descriptions.Item label="Service">
                    {item?.service?.title ?? item?.service?.name ?? "-"}
                </Descriptions.Item>
                <Descriptions.Item label="Cliente">
                    {item?.customer?.fullname ?? item?.customer?.name ?? "-"}
                </Descriptions.Item>

                <Descriptions.Item label="Longueur">{item?.length_key ?? "-"}</Descriptions.Item>
                <Descriptions.Item label="Dépose 3D">{item?.removal_3d ? "Oui" : "Non"}</Descriptions.Item>

                <Descriptions.Item label="Pose extérieure">{item?.outside_set ? "Oui" : "Non"}</Descriptions.Item>
                <Descriptions.Item label="Option">
                    {item?.option?.label ?? "-"} {item?.option?.type ? <Tag>{item.option.type}</Tag> : null}
                </Descriptions.Item>
            </Descriptions>

            <Divider />

            <Descriptions bordered size="small" column={3} loading={loading}>
                <Descriptions.Item label="Base">{money(item?.base_price)}</Descriptions.Item>
                <Descriptions.Item label="Option">{money(item?.option_price)}</Descriptions.Item>
                <Descriptions.Item label="Variable">{money(item?.option_variable_price)}</Descriptions.Item>

                <Descriptions.Item label="Total">{money(item?.total_price)}</Descriptions.Item>
                <Descriptions.Item label="Durée base">{item?.duration_min ? `${item.duration_min} min` : "-"}</Descriptions.Item>
                <Descriptions.Item label="Durée option">{item?.option_duration_min ? `${item.option_duration_min} min` : "-"}</Descriptions.Item>

                <Descriptions.Item label="Durée totale" span={3}>
                    {item?.total_duration_min ? `${item.total_duration_min} min` : "-"}
                </Descriptions.Item>
            </Descriptions>
        </Drawer>
    );
};

export default ShowAppointment;
